import React, { useState, useEffect, useRef } from "react";

import bgImage from "assests/About/8.jpg";
import image from "assests/About/7.jpg";
const Commitment = ({ data }) => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5, // Adjust the threshold as needed
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      });
    }, options);

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      style={{ backgroundImage: `url(${bgImage})` }}
      className="scroll-section relative"
    >
      <div className="flex flex-col-reverse lg:flex-row items-center h-full  gap-16">
        <div
          className={`flex-1 h-full flex flex-col justify-center  lg:text-end transition ease-in duration-500 special-container ${
            visible
              ? "opactity-100 translate-x-[0%] scale-1"
              : "opacity-0 translate-x-[-30%] scale-[0.6]"
          }`}
        >
          <h2 className="font-medium text-white text-4xl lg:text-5xl mb-2 uppercase bebas">
            {data?.title}
          </h2>

          <div
            className="text-white text-xl lg:w-1/2 lg:ml-auto text-justify leading-[1.6]"
            dangerouslySetInnerHTML={{ __html: data?.text }}
          />
        </div>
        <div className="flex-1 relative h-3/4">
          <div
            className={`absolute transition ease-in duration-700 w-full h-full inset-0 Lg:bg-black Lg:opacity-80  mix-blend-multiply ${
              visible ? "lg:translate-y-[100%]" : "lg:translate-y-[0%]"
            }`}
          ></div>
          <img className="h-full" src={data?.image} alt="" />
        </div>
      </div>
    </section>
  );
};

export default Commitment;
